import { render, staticRenderFns } from "./userDashboard.vue?vue&type=template&id=13ca0e63&"
import script from "./userDashboard.vue?vue&type=script&lang=js&"
export * from "./userDashboard.vue?vue&type=script&lang=js&"
import style0 from "./userDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports